export default "__VITE_ASSET__C8OY9UXL__"